<div class="metrics-panel">
  <!-- Header -->
  <div class="panel-header" (click)="toggleCollapsed()">
    <div class="header-left">
      <mat-icon class="header-icon">insights</mat-icon>
      <span class="header-title">Resumen del canal</span>
      <span *ngIf="metrics && !collapsed" class="header-subtitle">
        Últimos {{ metrics.dailySeries.length }} días · {{ metrics.total }} denuncias
      </span>
    </div>
    <mat-icon class="chevron">{{ collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
  </div>

  <!-- Body -->
  <div class="panel-body" *ngIf="!collapsed">

    <!-- Filtros de rango -->
    <div class="range-filter">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Desde</mat-label>
        <input matInput type="date" [(ngModel)]="dateFrom">
      </mat-form-field>
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Hasta</mat-label>
        <input matInput type="date" [(ngModel)]="dateTo">
      </mat-form-field>
      <button mat-stroked-button (click)="applyDateRange()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Actualizar
      </button>
      <button *ngIf="dateFrom || dateTo" mat-button (click)="clearDateRange()">
        Últimos 30 días
      </button>
    </div>

    <!-- Loading -->
    <div *ngIf="loading && !metrics" class="loading">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <!-- Contenido -->
    <div *ngIf="metrics" class="metrics-content">

      <!-- KPI cards -->
      <div class="kpi-grid">
        <div class="kpi-card">
          <div class="kpi-label">Total</div>
          <div class="kpi-value">{{ metrics.total }}</div>
        </div>

        <div class="kpi-card">
          <div class="kpi-label">Pendientes</div>
          <div class="kpi-value">{{ getStatusCount('RECIBIDA') + getStatusCount('EN_INVESTIGACION') }}</div>
          <div class="kpi-breakdown">
            <span><b>{{ getStatusCount('RECIBIDA') }}</b> recibidas</span>
            <span><b>{{ getStatusCount('EN_INVESTIGACION') }}</b> investigación</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-label">Cerradas</div>
          <div class="kpi-value">{{ getStatusCount('CONCLUIDA') + getStatusCount('DESESTIMADA') }}</div>
          <div class="kpi-breakdown">
            <span><b>{{ getStatusCount('CONCLUIDA') }}</b> concluidas</span>
            <span><b>{{ getStatusCount('DESESTIMADA') }}</b> desestimadas</span>
          </div>
        </div>

        <div class="kpi-card" [class.alert]="metrics.unassignedOldCount > 0">
          <div class="kpi-label">Sin asignar > 7d</div>
          <div class="kpi-value">{{ metrics.unassignedOldCount }}</div>
          <div class="kpi-breakdown" *ngIf="metrics.unassignedOldCount > 0">
            <span class="alert-text">Requiere atención</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-label">Tiempo a investigación</div>
          <div class="kpi-value">{{ formatHours(metrics.avgHoursToInvestigation) }}</div>
          <div class="kpi-breakdown">
            <span>Promedio</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-label">Tiempo a cierre</div>
          <div class="kpi-value">{{ formatHours(metrics.avgHoursToClosure) }}</div>
          <div class="kpi-breakdown">
            <span>Promedio</span>
          </div>
        </div>

        <div class="kpi-card">
          <div class="kpi-label">Anónimas</div>
          <div class="kpi-value">{{ metrics.anonymous.percentAnonymous }}%</div>
          <div class="kpi-breakdown">
            <span><b>{{ metrics.anonymous.anonymous }}</b> anónimas</span>
            <span><b>{{ metrics.anonymous.identified }}</b> identificadas</span>
          </div>
        </div>
      </div>

      <!-- Gráficos -->
      <div class="charts-row" *ngIf="lineChartData || statusChartData">
        <div class="chart-card" *ngIf="lineChartData">
          <div class="chart-title">Creación diaria</div>
          <div class="chart-wrapper">
            <canvas baseChart
              [data]="lineChartData"
              [options]="lineChartOptions"
              type="line">
            </canvas>
          </div>
        </div>

        <div class="chart-card" *ngIf="statusChartData">
          <div class="chart-title">Por estado</div>
          <div class="chart-wrapper">
            <canvas baseChart
              [data]="statusChartData"
              [options]="statusChartOptions"
              type="bar">
            </canvas>
          </div>
        </div>
      </div>

      <!-- Top operadores -->
      <div class="operators-row" *ngIf="topOperators.length">
        <div class="section-label">Carga por operador (top 3)</div>
        <div class="operators-list">
          <div *ngFor="let op of topOperators" class="operator-chip">
            <mat-icon>person</mat-icon>
            <span class="op-name">{{ op.operatorName }}</span>
            <span class="op-count">{{ op.total }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
